<!-- 文档预览组件 -->
<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="80%"
    top="2vh"
    class="preview-dialog"
    :before-close="handleClose"
  >
    <div v-loading="loading">
      <div v-if="showType === 'pdf'">
        <!-- <iframe :src="'/static/PDF/web/viewer.html?file=' + encodeURIComponent(newUrl)" width="100%" height="610px" frameborder="0"/> -->
        <iframe :src="newUrl" width="100%" height="762px" frameborder="0" />
      </div>
      <div v-else-if="showType === 'docx'" class="word-wrap">
        <div ref="docxFile" v-html="docxHtml"></div>
      </div>
      <el-image v-else-if="showType === 'picture'" fit="contain" :src="url">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
        <div slot="placeholder" class="image-slot">
          加载中<span class="dot">...</span>
        </div>
      </el-image>
      <div v-else-if="showType === 'xlsx'">
        <el-tabs tab-position="bottom" style="height: 200px">
          <el-tab-pane
            :label="item.name"
            v-for="(item, index) in tableArr"
            :key="index"
            v-html="item.value"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div v-else-if="showType === 'txt'" v-html="html"></div>
      <div v-else-if="showType === 'video'" style="text-align: center">
        <video :src="url" controls="controls">
          您的浏览器不支持 video 标签。
        </video>
      </div>
      <div v-else>该文件类型不支持在线预览</div>
    </div>
    <!--  <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">关 闭</el-button>
    </span> -->
  </el-dialog>
</template>

<script>
// import pdf from 'vue-pdf'
let docx = require("docx-preview");
import XLSX from "xlsx";
// import XLSX from 'xlsx-style'
// import './xlsx.full.min.js'
export default {
  // 还有一种通用的方法可查看所有文件的预览，需后台帮助部署 https://kkfileview.keking.cn/zh-cn/index.html
  name: "kyPreviewDialog",
  mixins: [],
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    url: {
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    blob: {
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      viewHtml: "",
      title: "",
      newUrl: "",
      tableArr: [],
      docxHtml: "",
      html:'',
      showType:''
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.showType = this.type.toLowerCase()
        if (this.showType === "pdf") {
          this.getPDF();
          this.title = "pdf预览";
        } else if (this.showType === "docx") {
          this.getDOCX();
          this.title = "word预览";
        } else if (this.showType === "picture" || this.showType==='jpg'||this.showType === 'jpeg'||this.showType ==='png'||this.showType === 'gif') {
          this.showType === "picture"
          this.title = "图片预览";
        } else if (this.showType === "xlsx") {
          this.getExcel();
          this.title = "excel预览";
        } else if (this.showType === "video" || this.showType === "mp3"||this.showType === "mp4"||this.showType === "flv"||this.showType === "avi") {
          this.showType === "video"
          this.title = "视频预览";
        } else if (this.showType === "txt") {
          this.getTxt();
          this.title = "txt预览";
        } else {
          this.title = "预览";
        }
        /* else if (this.type === 'pptx') {
        this.getPPT()
        this.title = 'ppt预览'
      } */
      }
    },
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    getPPT() {
      /*   const xhr = new XMLHttpRequest()
      xhr.open('get', this.url, true)
      xhr.responseType = 'blob'
      xhr.onload = () => {
        if (xhr.status === 200) {
          let blob = xhr.response
          let downloadElement = document.createElement('a')
          let href = blob
          if (typeof blob === 'string') {
            downloadElement.target = '_blank'
          } else {
            href = window.URL.createObjectURL(blob) // 创建下载的链接
          }
          downloadElement.href = href
          downloadElement.download = '前端vue学习' + '.' + 'ppt' // 下载后文件名
          document.body.appendChild(downloadElement)
          downloadElement.click() // 触发点击下载
          document.body.removeChild(downloadElement) // 下载完成移除元素
          if (typeof blob !== 'string') {
            window.URL.revokeObjectURL(href) // 释放掉blob对象
          }
        }
      }
      xhr.send() */
    },
    getPDF() {
      if (this.blob) {
        this.newUrl = "";
        const path = window.URL.createObjectURL(
          new Blob([this.blob], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        //   pdf.createLoadingTask(path)// pdf.createLoadingTask解决文件件跨域问题
        this.newUrl = path;
      } else if (this.url) {
        this.newUrl = this.url;
      }
    },
    getDOCX() {
      if (this.blob) {
        docx.renderAsync(this.blob, this.$refs.docxFile); // 渲染到页面预览
      } else if (this.url) {
        const xhr = new XMLHttpRequest();
        xhr.open("get", this.url, true);
        xhr.responseType = "blob";
        xhr.onload = () => {
          if (xhr.status === 200) {
            let blob = xhr.response;
            docx.renderAsync(blob, this.$refs.docxFile); // 渲染到页面预览
          }
        };
        xhr.send();
      }
    },
    getExcel() {
      if (this.blob) {
        let workbook = XLSX.read(new Uint8Array(this.blob), { type: "array" }); // 解析数据
        // eslint-disable-next-line no-unused-vars
        for (const item of workbook.SheetNames) {
          var worksheet = workbook.Sheets[item]; // workbook.SheetNames 下存的是该文件每个工作表名字
          this.tableArr.push({
            name: item,
            value: XLSX.utils.sheet_to_html(worksheet),
          });
        }
      } else if (this.url) {
        const xhr = new XMLHttpRequest();
        xhr.open("get", this.url, true);
        xhr.responseType = "arraybuffer";
        xhr.onload = () => {
          if (xhr.status === 200) {
            let blob = xhr.response;
            let workbook = XLSX.read(new Uint8Array(blob), { type: "array" }); // 解析数据
            // eslint-disable-next-line no-unused-vars
            for (const item of workbook.SheetNames) {
              var worksheet = workbook.Sheets[item]; // workbook.SheetNames 下存的是该文件每个工作表名字
              this.tableArr.push({
                name: item,
                value: XLSX.utils.sheet_to_html(worksheet),
              });
            }
          }
        };
        xhr.send();
      }
    },
    getTxt() {
        let that = this;
      if (this.blob) {
        let reader = new FileReader();
        reader.readAsText(this.blob);
        reader.onload = function () {
          that.html = this.result
        };
      } else if (this.url) {
        const xhr = new XMLHttpRequest();
        xhr.open("get", this.url, true);
        xhr.responseType = "blob";
        xhr.onload = () => {
          if (xhr.status === 200) {
            let blob = xhr.response;
            let reader = new FileReader();
            reader.readAsText(blob);
            reader.onload = function () {
              that.html = this.result
            };
          }
        };
        xhr.send();
      }
    },
    handleClose() {
      this.tableArr = [];
      this.$emit("update:visible", false);
    },
    prePage() {
      let page = this.pageNum;
      page = page > 1 ? page - 1 : this.pageTotalNum;
      this.pageNum = page;
    },
    nextPage() {
      let page = this.pageNum;
      page = page < this.pageTotalNum ? page + 1 : 1;
      this.pageNum = page;
    },
  },
  beforeDestroy() {},
  destroyed() {},
  beforeUpdate() {},
  updated() {},
};
</script>
<style lang='scss' scoped>
.preview-dialog {
  /deep/ .el-dialog__body {
    max-height: 779px;
    min-height: 300px;
    overflow: auto;
    padding: 15px 20px;
    .el-tabs {
      height: auto !important;
      .el-tabs__content {
        height: 727px;
        overflow: auto;
      }
    }
  }
}
.tool-bar {
  text-align: center;
}
.word-wrap {
  img {
    width: 100%;
  }
}
</style>
<style>
/*滚动条*/
::-webkit-scrollbar-track-piece {
  background-color: #fff;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #ccc;
  background-clip: padding-box;
  min-height: 28px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #ddd;
}
</style>



// WEBPACK FOOTER //
// packages/previewDialog/previewDialog.vue